import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../app/store";
import { postResetPassword } from "../authentificationSlice";
import { CompletePasswordResetRequest } from "../authModel";
import { useLocation } from "react-router-dom";
import { GetServerEmailError, ValidatePassword, ValidatePasswordContent } from "../../../app/validation";
import { useEmailErrorMessage } from "../../../UIComponents/Form/EmailField";
import { LoadingPage } from "../../CommonPages/loadingPage";
import { Dialog } from "@material-tailwind/react";
import ChangePasswordCard from "./changePasswordCard";
import SuccessCard from "../../CommonPages/successCard";
import { useTranslation } from "react-i18next";
import { AlertComponent } from "../../../UIComponents/Alert/AlertComponent";

export function ResetPassword() {
    const [hideMail, setHideMail] = useState(false);
    const [emailError, setEmailError] = useState<string | undefined>();
    const [errorMesssage, setErrorMesssage] = useState('');
    const [messsage, setMesssage] = useState('');
    const [open, setOpen] = useState(false);
    const [success, setSuccess] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const handleOpenDialog = () => setOpenDialog(!openDialog);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const { t } = useTranslation();
    const getEmailError = useEmailErrorMessage();
    const dispatch = useDispatch<AppDispatch>();
    const accountData = useSelector((state: RootState) => state.AccountSlice);
    const authentificationData = useSelector((state: RootState) => state.AuthentificationSlice);


    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (accountData.accountSliceData.accountData?.loggedUserData?.email !== '' && accountData.accountSliceData.accountData?.loggedUserData?.email !== 'undefined'
            && accountData.accountSliceData.accountData?.loggedUserData?.email !== null) {
            setHideMail(true)
        }
        else {
            setHideMail(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const submitFunction = (email: string, newPassword: string, confirmNewPassword: string) => {
        let mailToValid = hideMail ? accountData.accountSliceData.accountData?.loggedUserData?.email : email;

        const emailProblem = getEmailError(mailToValid);
        if (emailProblem) {
            // With hideMail the address comes from the account, not a field the
            // user can edit — so that one still has to go in the banner.
            if (hideMail) {
                setErrorMesssage(emailProblem);
                setOpen(true);
            } else {
                setEmailError(emailProblem);
            }
        }
        else if (newPassword === "" && confirmNewPassword === "") {
            setErrorMesssage(t("InsertBothPasswords"));
            setOpen(true);
        }
        else if (!ValidatePassword(newPassword, confirmNewPassword)) {
            setErrorMesssage(t("PasswordsAreNotTheSame"));
            setOpen(true);
        }
        else if (!ValidatePasswordContent(newPassword)) {
            setErrorMesssage(t("PasswordFormat"));
            setOpen(true);
        }
        else if (!ValidatePasswordContent(confirmNewPassword)) {
            setErrorMesssage(t("PasswordFormat"));
            setOpen(true);
        }
        else {
            let code = params.get('code');
            const resetPassReq: CompletePasswordResetRequest = { username: mailToValid, password: newPassword, code: code ?? '' };
            dispatch(postResetPassword(resetPassReq))
        }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (authentificationData.statusCode === '200') {
            setSuccess(true);
            setMesssage(t("PasswordChanged") ?? t("AnErrorOccurred"));
            handleOpenDialog();
        }
        else if (authentificationData.statusCode !== '') {
            // A 400 on the email is a fixable typo, so it goes on the field —
            // unless the address came from the account and has no field.
            const serverEmailError = GetServerEmailError(authentificationData.statusCode, authentificationData.error);
            if (serverEmailError && !hideMail) {
                setEmailError(serverEmailError);
                setOpen(false);
                return;
            }
            setSuccess(false);
            setMesssage(authentificationData.error ?? t("AnErrorOccurred"));
            handleOpenDialog();
        }
        setOpen(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authentificationData.statusCode])

    if (authentificationData.isLoading === true) {
        return (LoadingPage(authentificationData.isLoading))
    }

    return (
        <div className="flex justify-center m-[5%]">
            <form className="space-y-5">
                {errorMesssage !== "" ?
                    <AlertComponent open={open} onClose={() => setOpen(false)} message={errorMesssage} />
                    : <></>}
                <ChangePasswordCard hasMail={hideMail} onClickFunction={submitFunction} emailError={emailError} onEmailErrorClear={() => setEmailError(undefined)} />
            </form>
            <Dialog open={openDialog} handler={handleOpenDialog} size="xs" animate={{ mount: { scale: 1, y: 0 }, unmount: { scale: 0.9, y: -100 } }}>
                <SuccessCard onClickFunction={handleOpenDialog} text={messsage} success={success} />
            </Dialog>
        </div>
    );
}
